/* DD LAG module (single authoritative) */
(function () {
  if (window.__ddLagModuleLoaded) return;
  window.__ddLagModuleLoaded = true;

  function cfg() { return window.DD_LAG_CONFIG || {}; }

  function normalizePhrases(raw) {
    return (raw || "")
      .split(",")
      .map(s => s.trim().toLowerCase())
      .filter(Boolean);
  }

  function isEligibleByTitle() {
    var c = cfg();
    var title = (c.product_title || "").toLowerCase();
    if (!title) return false;
    var phrases = normalizePhrases(c.title_phrases_raw);
    for (var i = 0; i < phrases.length; i++) {
      if (phrases[i] && title.indexOf(phrases[i]) !== -1) return true;
    }
    return false;
  }

  function $(id) { return document.getElementById(id); }
  function hasLagDom() { return !!document.querySelector("[data-dd-lag-box]") && !!$("dd_lag_zip") && !!$("dd_lag_result"); }
  function sanitizeZip(z) { return (z || "").toString().replace(/\D/g, "").slice(0, 5); }

  function setResult(msg) {
    var el = $("dd_lag_result");
    if (el) el.textContent = msg || "";
  }

function setTag(optName, isRequired) {
  var label = document.querySelector('.dd-extra-option[data-lag-option="' + optName + '"]');
  if (!label) return;

  var tag = label.querySelector('.dd-extra-option__tag');
  if (!tag) return;

  label.classList.remove('dd-lag-required', 'dd-lag-optional');
  if (isRequired) {
    label.classList.add('dd-lag-required');
    tag.textContent = 'Required for LAG';
  } else {
    label.classList.add('dd-lag-optional');
    tag.textContent = 'Optional';
  }
}


  // ----- cookie helpers -----
  function setCookie(name, value, days) {
    try {
      var d = new Date();
      d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + d.toUTCString() + "; path=/";
    } catch (e) {}
  }
  function getCookie(name) {
    try {
      var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
      return m ? decodeURIComponent(m[1]) : "";
    } catch (e) { return ""; }
  }

  // ----- localStorage state (source of truth) -----
  function loadState() {
    var c = cfg();
    var key = c.storage_key || "dd_lag_state_v1";
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      var st = JSON.parse(raw);
      if (!st || typeof st !== "object") return null;
      return st;
    } catch (e) { return null; }
  }

  function saveState(st) {
    var c = cfg();
    var key = c.storage_key || "dd_lag_state_v1";
    try {
      localStorage.setItem(key, JSON.stringify(st));
      return true;
    } catch (e) { return false; }
  }

  function defaultState() {
    var c = cfg();
    var defReq = c.default_required || { heatpack: true, liner: true, hold: false };
    return {
      version: c.version || 1,
      initialized: true, // once created, we are initialized
      zip: "",
      selected: { heatpack: false, liner: false, hold: false },
      required: { heatpack: !!defReq.heatpack, liner: !!defReq.liner, hold: !!defReq.hold },
      weather: { city: "", state: "", temperature: null, checkedAt: null }
    };
  }

  function ensureInitializedStateOnce() {
    var c = cfg();
    var st = loadState();

    if (st && st.initialized) return st;

    // Not initialized yet -> read cookie ONCE (only here)
    st = st || defaultState();
    st.initialized = true;

    var cookieZip = sanitizeZip(getCookie(c.zip_cookie_name || "dd_lag_zip"));
    if (cookieZip.length === 5) {
      st.zip = cookieZip;

      // Refresh cookie expiry when read (configurable)
      setCookie(c.zip_cookie_name || "dd_lag_zip", cookieZip, Number(c.zip_cookie_days || 365));
    }

    saveState(st);
    return st;
  }

  // ----- UI sync from state -----
  function paintFromState(st) {
    if (!hasLagDom()) return;

    var zipEl = $("dd_lag_zip");
    if (zipEl) zipEl.value = st.zip || "";

    // Apply selected checkboxes (theme will display them; we set them to match state)
    var heat = $("user_heatpack");
    var liner = $("user_liner");
    var hold = $("user_hold");

    if (heat)  heat.checked  = !!(st.selected && st.selected.heatpack);
    if (liner) liner.checked = !!(st.selected && st.selected.liner);
    if (hold)  hold.checked  = !!(st.selected && st.selected.hold);

    // Tags are controlled ONLY by required flags (temperature algorithm)
    setTag("heatpack", !!(st.required && st.required.heatpack));
    setTag("liner",    !!(st.required && st.required.liner));
    setTag("hold",     !!(st.required && st.required.hold));

    // Result area: either city/state/temp or blank
    if (st.weather && (st.weather.city || st.weather.state || typeof st.weather.temperature === "number")) {
      var parts = [];
      if (st.weather.city) parts.push(st.weather.city);
      if (st.weather.state) parts.push(st.weather.state);
      var loc = parts.join(", ");
      var temp = (typeof st.weather.temperature === "number") ? (Math.round(st.weather.temperature) + "°F") : "";
      var msg = "";
      if (st.zip) msg += st.zip;
      if (loc) msg += (msg ? " • " : "") + loc;
      if (temp) msg += (msg ? " • " : "") + temp;
      setResult(msg);
    } else {
      setResult("");
    }
  }

  // ----- checkbox listeners (selection only) -----
  function bindSelectionListeners() {
    var heat = $("user_heatpack");
    var liner = $("user_liner");
    var hold = $("user_hold");

    function handler() {
      var st = ensureInitializedStateOnce();
      st.selected = st.selected || {};
      if (heat)  st.selected.heatpack = !!heat.checked;
      if (liner) st.selected.liner    = !!liner.checked;
      if (hold)  st.selected.hold     = !!hold.checked;
      saveState(st);
      // No tag changes here; tags are algorithm-only.
    }

    if (heat && !heat.__ddBound)  { heat.__ddBound = true;  heat.addEventListener("change", handler); }
    if (liner && !liner.__ddBound){ liner.__ddBound = true; liner.addEventListener("change", handler); }
    if (hold && !hold.__ddBound)  { hold.__ddBound = true;  hold.addEventListener("change", handler); }
  }

  // ----- weather pipeline -----
  async function fetchForecast(zip) {
    var c = cfg();
    var key = c.openweather_api_key || "";
    if (!key) throw new Error("Missing OpenWeather API key");

    var url = "https://api.openweathermap.org/data/2.5/forecast?zip=" +
      encodeURIComponent(zip) +
      ",US&units=imperial&appid=" + encodeURIComponent(key);

    var resp = await fetch(url, { method: "GET" });
    if (!resp.ok) {
      var err = new Error("OpenWeather error " + resp.status);
      if (resp.status === 404) err.code = "INVALID_ZIP";
      throw err;
    }
    return await resp.json();
  }

  function analyzeTemps(data) {
    if (!data || !data.list || !data.city) throw new Error("Malformed weather response");

    var tz = (typeof data.city.timezone === "number") ? data.city.timezone : 0; // seconds
    var nowUtc = Date.now();

    // Tomorrow+ 05:00–17:00 local
    var rows = [];
    for (var i = 0; i < data.list.length; i++) {
      var it = data.list[i];
      if (!it || !it.dt || !it.main) continue;

      var utcMs = it.dt * 1000;
      if (utcMs < nowUtc) continue;

      var localMs = utcMs + (tz * 1000);
      var d = new Date(localMs);
      var hour = d.getUTCHours();

      var nowLocal = new Date(nowUtc + (tz * 1000));
      var todayY = nowLocal.getUTCFullYear(), todayM = nowLocal.getUTCMonth(), todayD = nowLocal.getUTCDate();
      var y = d.getUTCFullYear(), m = d.getUTCMonth(), day = d.getUTCDate();

      var isTomorrowOrLater =
        (y > todayY) ||
        (y === todayY && m > todayM) ||
        (y === todayY && m === todayM && day > todayD);

      if (!isTomorrowOrLater) continue;
      if (hour < 5 || hour > 17) continue;

      var temp = (typeof it.main.temp === "number") ? it.main.temp : null;
      if (temp === null) continue;

      rows.push(temp);
    }

    // Fallback: first future point
    if (!rows.length) {
      for (var j = 0; j < data.list.length; j++) {
        var it2 = data.list[j];
        if (!it2 || !it2.dt || !it2.main) continue;
        var utcMs2 = it2.dt * 1000;
        if (utcMs2 < nowUtc) continue;
        var temp2 = (typeof it2.main.temp === "number") ? it2.main.temp : null;
        if (temp2 !== null) { rows.push(temp2); break; }
      }
    }

    var min = null, max = null;
    rows.forEach(function (t) {
      if (min === null || t < min) min = t;
      if (max === null || t > max) max = t;
    });

    return {
      city: data.city.name || "",
      state: "", // OpenWeather doesn’t reliably provide state in this endpoint
      min: min,
      max: max
    };
  }

  function decideProtections(analysis) {
    // Your rules:
    // heat pack if <=30
    // liner if <=25
    // hold if <25 OR >=90
    var min = (typeof analysis.min === "number") ? analysis.min : null;
    var max = (typeof analysis.max === "number") ? analysis.max : null;

    var heat = (min !== null) ? (min <= 30) : false;
    var liner = (min !== null) ? (min <= 25) : false;
    var hold = false;
    if (min !== null && min < 25) hold = true;
    if (max !== null && max >= 90) hold = true;

    // report temp
    var report = null;
    if (hold && max !== null && max >= 90) report = max;
    else if (min !== null) report = min;

    return { heatpack: heat, liner: liner, hold: hold, temperature: report };
  }

  async function runWeatherAndUpdateState(zip) {
    var data = await fetchForecast(zip);
    var a = analyzeTemps(data);
    var d = decideProtections(a);

    var st = ensureInitializedStateOnce();
    st.zip = zip;

    // Algorithm-only outputs
    st.required = { heatpack: !!d.heatpack, liner: !!d.liner, hold: !!d.hold };

    // Weather outputs
    st.weather = st.weather || {};
    st.weather.city = a.city || "";
    st.weather.state = a.state || "";
    st.weather.temperature = (typeof d.temperature === "number") ? d.temperature : null;
    st.weather.checkedAt = Date.now();

    // After a successful "Check", selections are reset to EXACTLY the required set.
    // If an option is not required, it becomes unchecked even if the customer had it checked previously.
    st.selected = {
      heatpack: !!(st.required && st.required.heatpack),
      liner:    !!(st.required && st.required.liner),
      hold:     !!(st.required && st.required.hold)
    };

    saveState(st);

    // Repaint UI (checkboxes + tags + result area) from state
    paintFromState(st);
  }

  // ----- Check button -----
  function bindCheckButton() {
    var btn = $("dd_lag_check");
    if (!btn || btn.__ddBound) return;
    btn.__ddBound = true;

btn.addEventListener("click", async function (e) {
  e.preventDefault();

  var zipEl = $("dd_lag_zip");
  var zip = sanitizeZip(zipEl ? zipEl.value : "");
  if (zipEl) zipEl.value = zip;

  // ✅ FIX: only error/return when ZIP is not 5 digits
  if (zip.length !== 5) {
    if (zipEl) zipEl.classList.add("dd-lag-input-error");
    setResult("Please enter a valid 5-digit ZIP code.");
    return;
  }

  if (zipEl) zipEl.classList.remove("dd-lag-input-error");

  setResult("Checking weather for " + zip + "…");

  try {
    await runWeatherAndUpdateState(zip);

    // On success, write cookie for configured duration
    var c = cfg();
    setCookie(c.zip_cookie_name || "dd_lag_zip", zip, Number(c.zip_cookie_days || 365));
  } catch (err) {
    if (err && err.code === "INVALID_ZIP") {
      if (zipEl) zipEl.classList.add("dd-lag-input-error");
      setResult("We could not find weather data for that ZIP. Please check and try again.");
      return;
    }
    setResult("Unable to fetch weather right now. Please try again.");
  }
});

  }

  // ----- staleness auto-refresh (optional) -----
  async function maybeAutoRefreshWeatherOnLoad(st) {
    // If we have a zip but no recent weather, refresh automatically
    var c = cfg();
    var staleMs = Number(c.weather_stale_ms || (24 * 3600000));

    if (!st.zip || st.zip.length !== 5) return;

    var checkedAt = st.weather && typeof st.weather.checkedAt === "number" ? st.weather.checkedAt : null;
    if (!checkedAt) {
      // If never checked, do it now
      try { await runWeatherAndUpdateState(st.zip); } catch (e) {}
      return;
    }

    if (Date.now() - checkedAt > staleMs) {
      try { await runWeatherAndUpdateState(st.zip); } catch (e2) {}
    }
  }

  // ----- Add to cart paths -----
  async function fetchCart() {
    try {
      var r = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
      if (!r.ok) return null;
      return await r.json();
    } catch (e) { return null; }
  }

  function ddUpdateHeaderCartCount(count) {
  try {
    var n = String(count == null ? 0 : count);

    // Common header cart count selectors (covers most themes)
    var selectors = [
      '[data-cart-count]',
      '[data-header-cart-count]',
      '.header__cart-count',
      '.cart-count-bubble span',
      '.cart-count-bubble',
      '.site-header__cart-count',
      '.cart-link__bubble-num',
      '.cart-count'
    ];

    var els = [];
    selectors.forEach(function (sel) {
      els = els.concat([].slice.call(document.querySelectorAll(sel)));
    });

    els.forEach(function (el) {
      // Prefer a child span if it exists
      var span = el.querySelector ? el.querySelector('span') : null;
      var target = span || el;
      target.textContent = n;

      // Hide/show behavior for zero
      if (Number(count) > 0) {
        el.classList.remove('is-hidden');
        el.removeAttribute('hidden');
      } else {
        el.classList.add('is-hidden');
        el.setAttribute('hidden', 'hidden');
      }
    });
  } catch (e) {
    // Best-effort only
  }
}


  function buttonSetLoading(btn, isLoading) {
    if (!btn) return;
    if (isLoading) {
      if (!btn.__ddOrigHtml) btn.__ddOrigHtml = btn.innerHTML;
      btn.innerHTML = "Adding to Cart…";
      btn.disabled = true;
    } else {
      if (btn.__ddOrigHtml) btn.innerHTML = btn.__ddOrigHtml;
      btn.disabled = false;
    }
  }

  function collectPropertiesFromForm(form) {
    try {
      var fd = new FormData(form);
      var props = {};
      for (var pair of fd.entries()) {
        var key = pair[0], val = pair[1];
        if (typeof key === "string" && key.indexOf("properties[") === 0) {
          var name = key.substring("properties[".length, key.length - 1);
          props[name] = val;
        }
      }
      return Object.keys(props).length ? props : null;
    } catch (e) { return null; }
  }

  // Public: standard add to cart (no extras) – still stays on page + shows "Adding..."
  window.ddStdAddToCart = async function (event) {
    try {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      }

      var btn = event && event.target && event.target.closest ? event.target.closest("button") : null;
      var form = btn && btn.closest ? btn.closest("form") : null;
      if (!form) return;

      buttonSetLoading(btn, true);

      var fd = new FormData(form);
      var id = fd.get("id");
      var qty = parseInt(fd.get("quantity") || "1", 10);
      if (isNaN(qty) || qty <= 0) qty = 1;

      var sellingPlan = fd.get("selling_plan");
      var props = collectPropertiesFromForm(form);

      var line = { id: id, quantity: qty };
      if (sellingPlan) line.selling_plan = sellingPlan;
      if (props) line.properties = props;

      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(line)
      });

      try {
        var cart2 = await fetchCart();
        if (cart2) {
          if (typeof window.ddUpdateHeaderCartCount === "function") {
            window.ddUpdateHeaderCartCount(cart2.item_count);
          } else {
            var el2 = document.querySelector('[data-cart-count], .header__cart-count, .cart-count, .cart-link__count');
            if (el2) el2.textContent = String(cart2.item_count);
          }
        }
      } catch (e2) {}

    } catch (e) {
      // no-op visible for now; could add a toast if desired
    } finally {
      var btn2 = event && event.target && event.target.closest ? event.target.closest("button") : null;
      buttonSetLoading(btn2, false);
    }
  };

  // Public: LAG batched add to cart (extras driven ONLY by selected.* in state)
  window.ddLagAddToCart = async function (event) {
    if (window.ddLagBusyAdd) return;
    window.ddLagBusyAdd = true;

    var btn = null;
    try {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        btn = event.target && event.target.closest ? event.target.closest("button") : null;
      }

      var form = btn && btn.closest ? btn.closest("form") : null;
      if (!form) return;

      buttonSetLoading(btn, true);

      var st = ensureInitializedStateOnce();

      // main product from form
      var fd = new FormData(form);
      var mainId = fd.get("id");
      var qty = parseInt(fd.get("quantity") || "1", 10);
      if (isNaN(qty) || qty <= 0) qty = 1;

      var sellingPlan = fd.get("selling_plan");
      var props = collectPropertiesFromForm(form);

      // Determine which extras to add ONLY from selected.*
      var selected = (st && st.selected) ? st.selected : { heatpack: false, liner: false, hold: false };

      // Ensure singleton extras: do not add if already in cart
      var cart = await fetchCart();
      var existing = new Set();
      if (cart && Array.isArray(cart.items)) {
        cart.items.forEach(function (it) { if (it && typeof it.id === "number") existing.add(it.id); });
      }

      var c = cfg();
      var items = [];

      var mainLine = { id: mainId, quantity: qty };
      if (sellingPlan) mainLine.selling_plan = sellingPlan;
      if (props) mainLine.properties = props;
      items.push(mainLine);

      if (selected.heatpack && c.heatpack_variant_id && !existing.has(Number(c.heatpack_variant_id))) {
        items.push({ id: c.heatpack_variant_id, quantity: 1 });
      }
      if (selected.liner && c.liner_variant_id && !existing.has(Number(c.liner_variant_id))) {
        items.push({ id: c.liner_variant_id, quantity: 1 });
      }
      if (selected.hold && c.holdpo_variant_id && !existing.has(Number(c.holdpo_variant_id))) {
        items.push({ id: c.holdpo_variant_id, quantity: 1 });
      }

      var resp = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items })
      });

      if (!resp.ok) {
        throw new Error("cart/add failed: " + resp.status);
      }

      // Optional but useful: consume JSON so errors surface consistently
      await resp.json();

      // ---- SUCCESS PATH: do your post-add behavior here ----
      if (typeof window.ddShowToast === "function") {
        window.ddShowToast("Added to cart");
      }
      // If you have a header cart-count updater, call it here too (optional).
      try {
        var cart = await fetchCart();
        if (cart) {
          if (typeof window.ddUpdateHeaderCartCount === "function") {
            window.ddUpdateHeaderCartCount(cart.item_count);
          } else {
            // Best-effort fallback for common themes
            var el = document.querySelector('[data-cart-count], .header__cart-count, .cart-count, .cart-link__count');
            if (el) el.textContent = String(cart.item_count);
          }
        }
      } catch (eCount) {
        // ignore
      }



    } catch (e) {
      // optionally: show a toast
    } finally {
      buttonSetLoading(btn, false);
      window.ddLagBusyAdd = false;
    }
  };

  // ----- boot per page -----
  function boot() {
    // Determine eligibility once; expose for Liquid/debug
    window.ddLagEnabledOnThisProduct = isEligibleByTitle();

    if (!window.ddLagEnabledOnThisProduct) return;
    if (!hasLagDom()) return;

    var st = ensureInitializedStateOnce();
    paintFromState(st);

    bindSelectionListeners();
    bindCheckButton();

    // If cookie seeded zip, ensure we have fresh-enough weather info
    maybeAutoRefreshWeatherOnLoad(st);
  }

  // Variant re-render: detect replacement of dd_lag_zip node and re-boot
  var lastZipNode = null;
  var scheduled = false;
  function scheduleBoot() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      var zipEl = $("dd_lag_zip");
      if (!zipEl) return;
      if (zipEl !== lastZipNode) {
        lastZipNode = zipEl;
        boot();
      }
    }, 60);
  }

  document.addEventListener("DOMContentLoaded", boot);

  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (!m.addedNodes) continue;
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (!n || n.nodeType !== 1) continue;
        if (n.id === "dd_lag_zip" || (n.querySelector && n.querySelector("#dd_lag_zip"))) {
          scheduleBoot();
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
